<div class="w-full bg-white border-box radius-10" style="border-radius: 10px;"
  [style.border]="isValidated ? '2px solid #28a745' : 'none'" id="list-verif">
  <div class="p-20 flex content-between" style="border-bottom: solid 1px #F0F5FF;">
    <div class="flex gap-10 align-items-center">
      <div>
        <div class="flex gap-10 align-items-center mb-5">
          <img *ngIf="!isValidated" src="assets/square-icon.svg" alt="">
          <img *ngIf="isValidated" src="assets/valid-square-icon.svg" alt="">
          <div>
            <p class="no-margin light-blue bold">Listes communes / Ententes syndicales</p>
            <p class="no-margin dark-gray text-sm">
              Bloc optionnel - Si applicable, renseignez les listes communes présentées lors de l'élection
            </p>
          </div>
        </div>
      </div>
      <app-tag [isValidated]="isValidated"></app-tag>
    </div>

    <div>
      <button (click)="toggleExpand()" class="pointer"
        style="background: none; border: none; cursor: pointer; font-size: 1.5rem; color: #4A90E2;">
        <span [style.transform]="isExpanded ? 'rotate(-90deg)' : 'rotate(90deg)'"
          style="display: inline-block; transition: transform 0.3s;">›</span>
      </button>
    </div>
  </div>


  <div *ngIf="isExpanded" id="information-grid" class="p-20">
    <p *ngIf="commonLists.length == 0" class="dark-gray no-margin bold">Aucune liste commune ajoutée</p>
    <div style="display: grid; grid-template-columns: repeat(2, 1fr); gap: 20px; border: solid 1px #DCEEFF;"
      class="bg-light-gray radius-10 p-20 mb-20"
      *ngFor="let commonList of commonLists; let i = index; trackBy: trackByIndex">
      <div style="grid-column: 1 / -1;" class="flex content-between align-items-center">
        <p class="light-blue bold">List commune {{i + 1}}</p>
      </div>
      <div>
        <p class="dark-gray no-margin">Nom de la liste commune</p>
        <p class="dark-blue bold">
          {{commonList.listName}}
        </p>
        <!-- <input [(ngModel)]="commonLists[i].listName" (ngModelChange)="onCommonListsChange()" type="text"
          name="commonList-{{i}}" id="commonList-{{i}}" maxlength="14" class="w-full text-md dark-blue pap-input"
          value="{{commonList}}"> -->
      </div>
      <div>
        <p class="dark-gray no-margin">Nom des syndicats entrant dans cette liste</p>
        <p class="dark-blue bold">
          {{commonList.listMembers}}
        </p>
        <!-- <input [(ngModel)]="commonLists[i].listMembers" (ngModelChange)="onCommonListsChange()" type="text"
          name="commonList-listMembers-{{i}}" id="commonList-listMembers-{{i}}"
          class="w-full text-md dark-blue pap-input" value="{{commonList}}"> -->

      </div>

      <div>
        <p class="dark-gray no-margin">Nom des organisations syndicales d'affiliation</p>
        <p class="dark-blue bold">
          {{commonList.listMembersFullName}}
        </p>
        <!-- <input [(ngModel)]="commonLists[i].listMembersFullName" (ngModelChange)="onCommonListsChange()" type="text"
          name="commonList-listMembersFullName-{{i}}" id="commonList-listMembersFullName-{{i}}" maxlength="14"
          class="w-full text-md dark-blue pap-input" value="{{commonList}}"> -->
      </div>

      <div>
        <p class="dark-gray no-margin">Répartition des suffrages entre organisations (en %)</p>
        <p class="dark-blue bold">
          {{commonList.composition}} %
        </p>
        <!-- <input [(ngModel)]="commonLists[i].composition" (ngModelChange)="onCommonListsChange()"
          (keypress)="onlyNumbers($event)" type="text" name="commonList-composition-{{i}}"
          id="commonList-composition-{{i}}" maxlength="14" pattern="[0-9]*" inputmode="numeric"
          class="w-full text-md dark-blue pap-input" value="{{commonList}}" max="100" min="0" maxlength="3"> -->
      </div>
    </div>

  </div>
  <div class="flex content-between p-20">
    <button class="edit-button" (click)="onEdit()">
      <img src="assets/pen-icon.svg" alt="">
      Modifier
    </button>
    <button *ngIf="!isValidated" class="validate-button" (click)="onValidate()">
      <img src="assets/valid-white-icon.svg" alt=""> Valider
    </button>
    <button *ngIf="isValidated" class="validated-button">
      <img src="assets/valid-green-icon.svg" alt="">
    </button>
  </div>
</div>